import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalRequestKpiDepartmentListService = (
  params: Types.ApprovalRequestKpiDepartmentListRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestKpiDepartmentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalRequestKpiDepartmentCreateService = (
  params: Types.ApprovalRequestKpiDepartmentCreateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestKpiDepartmentUpdateService = (
  params: Types.ApprovalRequestKpiDepartmentUpdateRequest
) =>
  RestAPIClient.call<RestAPIResponseList<Record<string, string>>>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalRequestKpiDepartmentDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalRequestKpiDepartment>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const approvalRequestKpiDepartmentApproveService = (
  params: Types.ApprovalRequestKpiDepartmentApproveRequest
) =>
  RestAPIClient.call<Types.ApprovalRequestKpiDepartment>({
    method: HTTPRequestMethods.POST,
    url: Paths.Approve,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
